import { Platform } from "react-native"
import { getFontSizeByWindowWidth } from "../utils/size"


const requireFonts = {
  SFProTextRegular:     require('../assets/fonts/SF-Pro-Text-Regular.otf'),
  SFProTextSemiBold:    require('../assets/fonts/SF-Pro-Text-Semibold.otf'),
  SFProDisplaySemiBold: require('../assets/fonts/SF-Pro-Display-Semibold.otf'),
  SFProDisplayBold:     require('../assets/fonts/SF-Pro-Display-Bold.otf'),
}

const requireFontsWeb = {
  Regular: require('../assets/fonts/Inter-Regular.otf'),
  Bold: require('../assets/fonts/Inter-Bold.otf'),
  
}

export const fonts = {
    BodyRegular: Platform.OS==='web'?requireFontsWeb.Regular:requireFonts.SFProTextRegular,
    Caption2Bold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProTextSemiBold,
    BodyBold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProTextSemiBold,
    Title3Bold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProDisplaySemiBold,
    Title2Bold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProDisplayBold,
    Title1Bold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProDisplayBold,
    LargeTitleBold: Platform.OS==='web'?requireFontsWeb.Bold:requireFonts.SFProDisplayBold,
}


export const fontSizes = {
  Caption2: Platform.OS!=='web'?getFontSizeByWindowWidth(11):11,
  Caption1:  Platform.OS!=='web'?getFontSizeByWindowWidth(12):12,
  Footnote:  Platform.OS!=='web'?getFontSizeByWindowWidth(13):13,
  Subheadline:  Platform.OS!=='web'?getFontSizeByWindowWidth(15):15,
  Callout:  Platform.OS!=='web'?getFontSizeByWindowWidth(16):16,
  Body:  Platform.OS!=='web'?getFontSizeByWindowWidth(17):17,
  Headline:  Platform.OS!=='web'?getFontSizeByWindowWidth(17):17,
  Title3:  Platform.OS!=='web'?getFontSizeByWindowWidth(20):20,
  Title2:  Platform.OS!=='web'?getFontSizeByWindowWidth(22):22,
  Title1:  Platform.OS!=='web'?getFontSizeByWindowWidth(28):28,
  LargeTitle:  Platform.OS!=='web'?getFontSizeByWindowWidth(34):34,
}

export const  lineHeights = {
  Caption2:  Platform.OS!=='web'?getFontSizeByWindowWidth(13):13,
  Caption1:  Platform.OS!=='web'?getFontSizeByWindowWidth(16):16,
  Footnote:  Platform.OS!=='web'?getFontSizeByWindowWidth(18):18,
  Subheadline:  Platform.OS!=='web'?getFontSizeByWindowWidth(20):20,
  Callout:  Platform.OS!=='web'?getFontSizeByWindowWidth(21):21,
  Body:  Platform.OS!=='web'?getFontSizeByWindowWidth(22):22,
  Headline:  Platform.OS!=='web'?getFontSizeByWindowWidth(22):22,
  Title3:  Platform.OS!=='web'?getFontSizeByWindowWidth(25):25,
  Title2:  Platform.OS!=='web'?getFontSizeByWindowWidth(28):28,
  Title1:  Platform.OS!=='web'?getFontSizeByWindowWidth(34):34,
  LargeTitle:  Platform.OS!=='web'?getFontSizeByWindowWidth(41):41,
}

export const letterSpacings = {
  Caption2: Platform.OS==='web'?0.07:getFontSizeByWindowWidth(0.07),
  Caption1: Platform.OS==='web'?0.00:getFontSizeByWindowWidth(0.00),
  Footnote: Platform.OS==='web'?-0.08:getFontSizeByWindowWidth(-0.08),
  Subheadline: Platform.OS==='web'?-0.24:getFontSizeByWindowWidth(-0.24),
  Callout: Platform.OS==='web'?-0.32:getFontSizeByWindowWidth(-0.32),
  Body: Platform.OS==='web'?-0.41:getFontSizeByWindowWidth(-0.41),
  Headline: Platform.OS==='web'?-0.41:getFontSizeByWindowWidth(-0.41),
  Title3: Platform.OS==='web'?0.38:getFontSizeByWindowWidth(0.38),
  Title2: Platform.OS==='web'?0.35:getFontSizeByWindowWidth(0.35),
  Title1: Platform.OS==='web'?0.36:getFontSizeByWindowWidth(0.36),
  LargeTitle: Platform.OS==='web'?0.37:getFontSizeByWindowWidth(0.37),
}